export default __webpack_public_path__ + "static/media/borrow-nerd.4f212f8e.svg";